import React, { useEffect } from 'react';
import {
	useHealthPlanWorkplaceQuery,
	useUpdateHealthPlanWorkplaceMutation,
} from '../../../../graphql/graphql';
import MagicForm from '../../../../Components/Form/MagicForm';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';
import useNotification from '../../../../Hooks/useNotification.hook';
import useApiClient from '../../../Base/Hooks/useApiClient';
import Loading from '../../../../Components/Loading';

interface HealthPlanSettingsValues {
	periodontalItemsCount: {
		value: string;
		label: string;
		title: string;
	};
}

interface Props {
	healthPlanId: string;
	onSuccess: () => void;
}

const WorkplaceHealthPlanEditForm = ({ healthPlanId, onSuccess }: Props) => {
	const { data, isLoading, refetch } = useHealthPlanWorkplaceQuery({
		where: { healthPlanId },
	});
	const [updateHealthPlanWorkplace] = useUpdateHealthPlanWorkplaceMutation();
	const { showNotificationSuccess } = useNotification();
	const { displayGQLError } = useApiClient();

	useEffect(() => {
		refetch();
	}, [healthPlanId, refetch]);

	const item = data?.healthPlanWorkplaceByHealthPlanId;

	const handleSubmit = async (values: HealthPlanSettingsValues) => {
		if (!item) return;

		const response = await updateHealthPlanWorkplace({
			where: { id: item.id },
			input: {
				settings: {
					...item.settings,
					periodontalItemsCount: parseInt(values.periodontalItemsCount.value),
				},
			},
		});

		if ('error' in response) {
			displayGQLError(response);
		} else {
			showNotificationSuccess({
				content: 'component.healthPlan.editSettingsSuccess',
			});
			onSuccess();
		}
	};

	const defaultValues: HealthPlanSettingsValues = {
		periodontalItemsCount: item?.settings?.periodontalItemsCount,
	};

	const formScheme: ItemScheme[] = [
		{
			type: MagicField.SELECT,
			key: 'periodontalItemsCount',
			title: 'component.healthPlan.settingPeriodontalItemCount',
			children: [
				{ value: '4', label: '4', title: '4' },
				{ value: '6', label: '6', title: '6' },
			],
			settings: {
				required: true,
			},
		},
	];

	if (isLoading) {
		return <Loading />;
	}

	return (
		<MagicForm
			formScheme={formScheme}
			defaultValues={defaultValues}
			onSubmit={handleSubmit}
			submitText={'base.shared.form.send'}
		/>
	);
};

export default WorkplaceHealthPlanEditForm;
